import * as anchor from '@coral-xyz/anchor';

export const U64_MAX = new anchor.BN('18446744073709551615');
